import { ReactNode } from 'react'

import { FeatureFlagsContext } from './FeatureFlagsContext'
import { Environment, FeatureFlags } from './types'
import devFeatureFlags from './feature-flags.dev.json'
import prodFeatureFlags from './feature-flags.prod.json'
import { getEnvironment } from './getEnvironment'

function isValidEnv(environment: unknown): environment is Environment {
    return (
        typeof environment === 'string' &&
        ['dev', 'uat', 'prod', 'local'].includes(environment)
    )
}

const getFeatureFlags: () => FeatureFlags = () => {
    const environment = getEnvironment()

    if (!isValidEnv(environment)) {
        return {}
    }

    if (environment === 'prod' || environment === 'uat') {
        return prodFeatureFlags
    }

    return devFeatureFlags
}

export function FeatureFlagsProvider({ children }: { children: ReactNode }) {
    const featureFlags = getFeatureFlags()

    return (
        <FeatureFlagsContext.Provider value={featureFlags}>
            {children}
        </FeatureFlagsContext.Provider>
    )
}
